import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Image } from "@react-pdf/renderer";
import { formatNumber } from "../../widgets/FormatNumber";
import { formatDateddMMMyyyy } from "../../widgets/DateTime";

const styles = StyleSheet.create({
    page: { padding: 30 },
    title: { fontSize: 20, marginLeft: 170, marginTop: -50 },
    logo: { width: 120, height: 110 },
    header: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        marginBottom: 20
    },
    body: {
        marginTop: 40,
        fontSize: 12,
        lineHeight: 1.5,
        textAlign: "justify"
    }
});

const MyDocument = ({ selectedPlanDetail, Nit, NameCompany }) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Image style={styles.logo} src="/Logo completo.png" />
                <Text style={styles.title}>CERTIFICADO DE COMPRA</Text>
                <Text style={styles.body}>
                    <Text style={{ fontWeight: 'bold' }}>TAE-COL SAS</Text> identificada con NIT <Text style={{ fontWeight: 'bold' }}>901846290-9</Text> certifica que la razon social <Text style={{ fontWeight: 'bold' }}>{NameCompany}</Text>,
                    identificado(a) con <Text style={{ fontWeight: 'bold' }}>NIT/CC {Nit}</Text> realizó la compra de los siguientes productos/servicios: {"\n\n"}
                    <Text style={{ fontWeight: 'bold' }}>Producto/Servicio:</Text> {selectedPlanDetail.plan} {"\n\n"}
                    <Text style={{ fontWeight: 'bold' }}>Cantidad:</Text> {formatNumber(selectedPlanDetail.foliosAnual)} Folios {"\n\n"}
                    <Text style={{ fontWeight: 'bold' }}>Valor unitario:</Text> $ {formatNumber(selectedPlanDetail.valorMensual)} {"\n\n"}
                    <Text style={{ fontWeight: 'bold' }}>Valor total:</Text> $ {formatNumber(selectedPlanDetail.valorAnual)} {"\n\n"}
                    <Text style={{ fontWeight: 'bold' }}>Fecha de compra:</Text> {formatDateddMMMyyyy(selectedPlanDetail.fechaInicio)} {"\n\n"}
                    <Text style={{ fontWeight: 'bold' }}>Fecha de Vencimiento:</Text> {formatDateddMMMyyyy(selectedPlanDetail.fechaFin)} {"\n\n"}
                    Este certificado se expide como constancia de la transacción realizada y no reemplaza la factura de venta, la cual ha sido emitida conforme a la normatividad legal vigente.
                </Text>
            </Page>
        </Document>
    )
}

export default MyDocument;